import React from "react";
import { t } from "i18next";
import moment from "moment";
import { exportEmployees, getMany, softDeleteById } from "services/employee";
import { Util } from "common/util";
import {
  Badge,
  InputDate,
  Tooltip,
  Tag,
  Spin,
  Result
} from "common/elements";
import { getHostURl } from "services/core";
import withDataTable from "./withDataTable";
import Enum from "common/enums";
import { useNavigate } from "react-router-dom";

const pathName = "employees";

const columns = [
  {
    title: t("text_code"),
    dataIndex: "code",
    key: "code",
    width: 120
  },
  {
    title: t("text_employee_name"),
    dataIndex: "name",
    key: "index",
    render: (employeeName, record) => {
      return (
        <div className="title" id="leave-title">
          <div
            className="profile"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="task-image">
              {record.photo ? (<img src={`${getHostURl()}/public/uploads/profile/${record.photo}?v=${Date.now()}`} alt="employee profile" />) : (
                <span>
                  {employeeName && Util.getInstance().getFristCharater(employeeName)}
                </span>
              )}
            </div>
            <div style={{ marginLeft: "20px" }}>
              {employeeName} {record.id === Util.getInstance().getCurrentUser().id && <Tag color="success">It's you</Tag>}
              {
                moment().diff(moment(record.joinDate), "months") < 3 &&
                <Badge
                  className="site-badge-count-109"
                  count={"New"}
                  style={{
                    backgroundColor: "#52c41a",
                    position: "absolute",
                    top: -20,
                    right: -36
                  }}
                />
              }

            </div>
          </div>
        </div>
      );
    }
  },
  {
    title: t("text_gender"),
    dataIndex: "gender",
    key: "gender",
    width: 100,
    align: "center",
    render: gender => gender === 0 ? "M" : "F",
  },
  {
    title: t("text_position"),
    dataIndex: "position",
    key: "position"
  },
  {
    title: t("text_date_of_employment"),
    dataIndex: "joinDate",
    key: "joinDate",
    render: joinDate => joinDate && Util.getInstance().formatDate(joinDate, "MMM DD, YYYY")
  },
  {
    title: t("text_probation_expired_date"),
    dataIndex: "probationExpiredDate",
    key: "probationExpiredDate",
    render: probationExpiredDate => probationExpiredDate && Util.getInstance().formatDate(probationExpiredDate, "MMM DD, YYYY")
  },
  {
    title: t("text_status"),
    dataIndex: "status",
    key: "status",
    align: "center",
    width: 130,
    render: (status, record) => {
      if (status === 1)
        return <div className="shift-flexbox">
          <div className="shift-margin-enable"></div>
          <span>{t("text_active")}</span>
        </div>;

      if (status === 0) {
        if (record.isNoticeTerminate === Enum.NOTICE_TERMINATION.YES) {
          return <Tooltip title={`Last working day ${Util.getInstance().formatDate(record.lastWorkingDay, "MMM DD, YYYY")}`}>
            <div className="shift-flexbox">
              <div className="shift-margin-disable" style={{ backgroundColor: "#f21b1b" }} />
              <span>Terminated</span>
            </div>
          </Tooltip>;
        } else {
          return <Tooltip title={`Last working day ${Util.getInstance().formatDate(record.lastWorkingDay, "MMM DD, YYYY")}`}>
            <div className="shift-flexbox">
              <div className="shift-margin-disable"></div>
              <span>{t("text_resigned")}</span>
            </div>
          </Tooltip>;
        }
      }
    }
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {
    contractExpired: false,
    isResigned: false,
    newHire: false,
  };
  let filter = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (params.get("join-date")) {
    filter["joinDate"] = params.get("join-date");
  }

  if (params.get("contractExpired")) {
    option["contractExpired"] = params.get("contractExpired");
  }

  if (params.get("newHire")) {
    option["newHire"] = params.get("newHire");
  }

  if (params.get("isResigned")) {
    option["isResigned"] = params.get("isResigned");
  }

  if (Object.keys(filter).length) {
    option["filter"] = JSON.stringify(filter);
  }
  

  if (searchStr) {
    option["search"] = JSON.stringify({
      column: ["name", "code", "position"],
      value: searchStr,
    });
  }
  return getMany(option);
};

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);
  let searchStr = `search=${value}`;

  if (params.get("join-date")) {
    searchStr += `&join-date=${params.get("join-date")}`;
  }

  Util.getInstance().pushParamsToURL(pathName, searchStr);
};

const onChangeJoinDate = (value) => {
  const params = new URLSearchParams(document.location.search);
  let searchStr = "";
  let symbol = "";
  if (params.get("search")) {
    searchStr += `search=${params.get("search")}`;
    symbol = "&";
  }

  if (value) {
    searchStr += `${symbol}join-date=${moment(value).format("DD-MM-YYYY")}`;
  }

  Util.getInstance().pushParamsToURL(pathName, searchStr);
};

const filterFields = () => {
  let joinDate = "";
  const params = new URLSearchParams(document.location.search);

  if (params.get("joinDate")) {
    joinDate = moment(params.get("joinDate"));
  }
  return (
    <>
      <InputDate
        name="joinDate"
        label={t("text_join_date")}
        placeholder={t("text_join_date")}
        initialValue={joinDate}
        format="DD/MM/YYYY"
        onChange={onChangeJoinDate}
        allowClear={true}
        style={{ width: "100%", margin: "10px 0" }}
      />
    </>
  );
};

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let limit = defaultPageSize;
    let current = defaultCurrent;
    let option = {
      contractExpired: false,
      isResigned: false,
      newHire: false,
    };
    let filter = {};
    const searchStr = params.get("search");
  
    if (params.get("size")) {
      limit = params.get("size");
    }
  
    if (params.get("current")) {
      current = params.get("current");
    }
  
    option["limit"] = limit;
    option["offset"] = (current - 1) * limit;
  
    if (params.get("join-date")) {
      filter["joinDate"] = params.get("join-date");
    }
  
    if (params.get("contractExpired")) {
      option["contractExpired"] = params.get("contractExpired");
    }
  
    if (params.get("newHire")) {
      option["newHire"] = params.get("newHire");
    }
  
    if (params.get("isResigned")) {
      option["isResigned"] = params.get("isResigned");
    }
  
    if (Object.keys(filter).length) {
      option["filter"] = JSON.stringify(filter);
    }
    
  
    if (searchStr) {
      option["search"] = JSON.stringify({
        column: ["name", "code", "position"],
        value: searchStr,
      });
    }
    exportEmployees(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title={t(
            "text_successfully_exported_employees"
          )}
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>,
          ]}
        />
      )}
    </>
  );
};

export default withDataTable({
  title: t("text_employees"),
  addNewLink: "/employees/create",
  updateLink: "/employees/update",
  addViewLink: "/employees/profile",
  filterParams: ["join-date"],
  topFilterItems: [],
  showButtonDelete: true,
  showPagination: true,
  showButtonInfo: true,
  showButtonImport: true,
  showExport: true,
  buttonOption: ExportFormLoader,
  noneButton: "",
  columns,
  pathName,
  defaultCurrent,
  defaultPageSize,
  permission: "employee",
  filterFields,
  handleSearch,
  getData,
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  confirmSoftDelete: (id) => softDeleteById(id),
});
